import { setDrawerOpen } from 'features/ui/model/uiSlice';
import CloseIcon from '@mui/icons-material/Close';
import { Drawer, Typography, IconButton, TextField, Button, Box } from '@mui/material';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { Controller, useForm } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from 'app/store';
import { useCreateBannerTypeMutation } from 'widgets/content/ui/banner-type/api/BannerTypeController';

type FormDataType = {
  title: string;
};

export const DrawerBannerType = () => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);

  const {
    control,
    formState: { errors: formErrors },
  } = useForm<FormDataType>({
    defaultValues: {
      title: '',
    },
  });

  const [creatBannerType] = useCreateBannerTypeMutation();

  const createTypeBanner = () => {
    const a = {
      title: control._fields.title?._f.value,
    };
    creatBannerType(JSON.stringify(a)).then(() => {
      dispatch(setDrawerOpen(false));
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    });
  };

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            Создать тип баннера
          </Typography>
          <IconButton
            onClick={() => dispatch(setDrawerOpen(false))}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          <div>
            <div style={{ marginBottom: '20px' }}>Информация о типе баннера</div>
            <Controller
              name="title"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Наименование"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.title && true}
                  {...field}
                />
              )}
            />
          </div>

          <Box
            sx={{
              display: 'flex',
              marginTop: '30px',
            }}
          >
            <Button
              variant="contained"
              sx={{ textTransform: 'none' }}
              onClick={createTypeBanner}
            >
              Создать
            </Button>
          </Box>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
